document.addEventListener('DOMContentLoaded', function () {
  /* Mobile menu toggle */
  var toggle = document.getElementById('mobileMenuToggle');
  var nav = document.getElementById('mainNav');
  var navClose = document.getElementById('navClose');
  var overlay = document.getElementById('navOverlay');

  function openNav() {
    if (nav) nav.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    if (toggle) toggle.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    if (nav) nav.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (toggle) toggle.classList.remove('is-active');
    document.body.style.overflow = '';
    // Close all expanded submenus
    if (nav) {
      nav.querySelectorAll('.header__menu-item--has-dropdown.is-expanded').forEach(function (item) {
        item.classList.remove('is-expanded');
      });
    }
  }

  // Toggle also closes (tap hamburger when open = close)
  if (toggle) {
    toggle.addEventListener('click', function () {
      if (nav && nav.classList.contains('is-open')) {
        closeNav();
      } else {
        openNav();
      }
    });
  }

  if (navClose) {
    navClose.addEventListener('click', closeNav);
  }
  if (overlay) {
    overlay.addEventListener('click', closeNav);
  }

  // Close nav on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* Mobile submenu expand/collapse - direct binding for reliability */
  document.querySelectorAll('.header__menu-item--has-dropdown').forEach(function (dropdown) {
    var link = dropdown.querySelector('.header__menu-link');
    if (!link) return;
    link.addEventListener('click', function (e) {
      // Only intercept on mobile
      if (!window.matchMedia('(max-width: 768px)').matches) return;
      e.preventDefault();
      // Close other expanded items
      dropdown.parentElement.querySelectorAll('.header__menu-item--has-dropdown.is-expanded').forEach(function (item) {
        if (item !== dropdown) item.classList.remove('is-expanded');
      });
      dropdown.classList.toggle('is-expanded');
    });
  });

  /* Smooth scroll for anchor links */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  /* Crystal guide responsive grid columns */
  var guideSection = document.querySelector('.crystal-guide');
  if (guideSection) {
    var grid = guideSection.querySelector('.crystal-guide__grid');
    var style = getComputedStyle(document.documentElement);
    var cols = style.getPropertyValue('--guide-columns');
    if (cols && grid) {
      grid.style.gridTemplateColumns = 'repeat(' + cols.trim() + ', 1fr)';
    }
  }

  /* ========================================
     Product Page Interactions
     ======================================== */

  /* Thumbnail Gallery (desktop) */
  document.querySelectorAll('.product__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var section = this.closest('[data-section]');
      if (!section) return;
      var mainImg = section.querySelector('.product__main-image img');
      if (mainImg) {
        mainImg.src = this.dataset.imageUrl;
        mainImg.alt = this.dataset.alt || '';
      }
      section.querySelectorAll('.product__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      var idx = parseInt(this.dataset.index) || 0;
      section.querySelectorAll('.product__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    });
  });

  /* Mobile Gallery: Swipe + Dots */
  document.querySelectorAll('.product__main-image').forEach(function (gallery) {
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) return;

    var section = gallery.closest('[data-section]');
    if (!section) return;

    var dots = section.querySelectorAll('.product__dot');
    var thumbs = section.querySelectorAll('.product__thumb');
    var images = [];

    thumbs.forEach(function (t) {
      images.push({ url: t.dataset.imageUrl, alt: t.dataset.alt || '' });
    });

    if (images.length <= 1) return;

    var mainImg = gallery.querySelector('img');
    var currentIndex = 0;
    var touchStartX = 0;
    var SWIPE_THRESHOLD = 50;

    function goToImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      currentIndex = index;
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = images[currentIndex].url;
          mainImg.alt = images[currentIndex].alt;
          mainImg.style.opacity = '1';
        }, 150);
      }
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === currentIndex); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === currentIndex); });
    }

    gallery.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    gallery.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > SWIPE_THRESHOLD) {
        goToImage(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
    }, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToImage(parseInt(this.dataset.index) || 0);
      });
    });
  });

  /* Product Quantity Selector */
  document.querySelectorAll('.product__quantity-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.parentElement.querySelector('.product__quantity-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') {
        input.value = val + 1;
      } else if (this.dataset.action === 'decrease' && val > 1) {
        input.value = val - 1;
      }
      input.dispatchEvent(new Event('change'));
    });
  });

  /* Variant Selector */
  document.querySelectorAll('.product__swatch, .product__option-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var container = this.closest('.product__option');
      if (!container) return;
      container.querySelectorAll('.product__swatch, .product__option-btn').forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
    });
  });

  /* Tab toggle icon */
  document.querySelectorAll('.product__tab').forEach(function (tab) {
    tab.addEventListener('toggle', function () {
      var icon = this.querySelector('.product__tab-icon');
      if (icon) {
        icon.textContent = this.open ? '×' : '+';
      }
    });
  });

  /* Mobile Sticky Add-to-Cart Bar */
  document.querySelectorAll('.product__sticky-bar').forEach(function (bar) {
    var section = bar.closest('[data-section]');
    if (!section) return;
    var purchaseArea = section.querySelector('.product__purchase');
    if (!purchaseArea) return;

    function checkSticky() {
      var rect = purchaseArea.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    }

    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  });

  /* ========================================
     Cart Drawer
     ======================================== */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartOverlay = document.getElementById('CartOverlay');
  var cartIcon = document.getElementById('CartIcon');
  var cartClose = document.getElementById('CartDrawerClose');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  }

  if (cartClose) {
    cartClose.addEventListener('click', closeCartDrawer);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  // Close on ESC
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* ========================================
     Cart AJAX Operations
     ======================================== */

  function updateCartCount(count) {
    var el = document.getElementById('CartCount');
    if (el) el.textContent = count;
    var drawerCount = document.getElementById('CartDrawerCount');
    if (drawerCount) drawerCount.textContent = '(' + count + ')';
  }

  // Add to cart via AJAX
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id.indexOf('AddToCartForm') === -1) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      // Update cart count
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      // Refresh drawer content
      refreshCartDrawer();
      openCartDrawer();

      if (submitBtn) {
        submitBtn.textContent = 'Added ✦';
        setTimeout(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }, 1500);
      }
    })
    .catch(function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    });
  });

  // Cart item quantity changes (drawer + page)
  function bindCartQtyButtons() {
    document.querySelectorAll('.cart-item__qty-btn, .cart-page-item__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrapper = this.closest('.cart-item__qty, .cart-page-item__qty');
        if (!wrapper) return;
        var input = wrapper.querySelector('input');
        if (!input) return;
        var val = parseInt(input.value) || 0;
        if (this.dataset.action === 'increase') {
          val++;
        } else if (this.dataset.action === 'decrease') {
          val--;
        }
        if (val < 0) val = 0;
        input.value = val;
        updateCartItem(input.dataset.key, val);
      });
    });

    document.querySelectorAll('.cart-item__qty-input, .cart-page-item__qty-input').forEach(function (input) {
      var debounce;
      input.addEventListener('change', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () {
          var val = parseInt(input.value) || 0;
          updateCartItem(input.dataset.key, val);
        }, 400);
      });
    });

    // Remove buttons
    document.querySelectorAll('.cart-item__remove, .cart-page-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCartItem(this.dataset.key, 0);
      });
    });
  }

  bindCartQtyButtons();

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
      // If on cart page, reload to reflect changes
      if (document.querySelector('.cart-page')) {
        window.location.href = '/cart';
      }
    });
  }

  function refreshCartDrawer() {
    // Fetch the page and extract the drawer HTML
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('.cart-drawer');
        var newOverlay = doc.querySelector('.cart-overlay');
        var currentDrawer = document.querySelector('.cart-drawer');
        var currentOverlay = document.querySelector('.cart-overlay');

        if (newDrawer && currentDrawer) {
          // Preserve open state
          var wasOpen = currentDrawer.classList.contains('is-open');
          currentDrawer.innerHTML = newDrawer.innerHTML;
          if (wasOpen) currentDrawer.classList.add('is-open');
          bindCartQtyButtons();
        }
      })
      .catch(function () {
        // Silently fail - drawer will update on next open
      });
  }

  /* ========================================
     Cart Page Specific Interactions
     ======================================== */

  // Gift note toggle
  var giftToggle = document.getElementById('GiftToggle');
  var giftNote = document.getElementById('GiftNote');
  if (giftToggle && giftNote) {
    giftToggle.addEventListener('change', function () {
      giftNote.classList.toggle('is-visible', this.checked);
      if (!this.checked) {
        giftNote.value = '';
      }
    });
    // Init state
    if (giftNote.value && giftNote.value.trim().length > 0) {
      giftToggle.checked = true;
      giftNote.classList.add('is-visible');
    }
  }

  // Promo code toggle
  var promoToggle = document.getElementById('PromoToggle');
  var promoForm = document.getElementById('PromoForm');
  if (promoToggle && promoForm) {
    promoToggle.addEventListener('click', function () {
      promoForm.classList.toggle('is-visible');
      if (promoForm.classList.contains('is-visible')) {
        promoForm.querySelector('input').focus();
      }
    });
  }

  /* ========================================
     Collection Page: Filter Drawer + Sort
     ======================================== */
  var filterToggle = document.getElementById('FilterToggle');
  var filterClose = document.getElementById('FilterClose');
  var filterOverlay = document.getElementById('FilterOverlay');
  var collectionFilters = document.getElementById('CollectionFilters');

  function openFilters() {
    if (collectionFilters) collectionFilters.classList.add('is-open');
    if (filterOverlay) filterOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (collectionFilters) collectionFilters.classList.remove('is-open');
    if (filterOverlay) filterOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (filterToggle) filterToggle.addEventListener('click', openFilters);
  if (filterClose) {
    filterClose.querySelector('.collection-filters__close-btn').addEventListener('click', closeFilters);
  }
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);

  // Sort by URL param
  var sortBy = document.getElementById('SortBy');
  if (sortBy) {
    var urlParams = new URLSearchParams(window.location.search);
    var currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortBy.value = currentSort;
    }
    sortBy.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', this.value);
      window.location.search = params.toString();
    });
  }

  /* ========================================
     Product List Page: Client-side Sort
     ======================================== */
  var productListSort = document.getElementById('ProductListSort');
  if (productListSort) {
    productListSort.addEventListener('change', function () {
      var grid = document.getElementById('ProductListGrid');
      if (!grid) return;
      var items = Array.from(grid.querySelectorAll('.product-list-grid__item'));
      var sortValue = this.value;

      items.sort(function (a, b) {
        switch (sortValue) {
          case 'price-ascending':
            return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
          case 'price-descending':
            return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
          case 'title-ascending':
            return a.dataset.title.localeCompare(b.dataset.title);
          case 'title-descending':
            return b.dataset.title.localeCompare(a.dataset.title);
          case 'created-descending':
            return parseInt(b.dataset.created) - parseInt(a.dataset.created);
          case 'best-selling':
            return parseInt(a.dataset.bestSelling) - parseInt(b.dataset.bestSelling);
          case 'manual':
          default:
            return parseInt(a.dataset.manual) - parseInt(b.dataset.manual);
        }
      });

      // Re-append sorted items
      items.forEach(function (item) {
        grid.appendChild(item);
      });
    });
  }

  // Active filter tag removal
  document.querySelectorAll('.collection-toolbar__filter-tag-remove').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = this.dataset.url;
    });
  });

  /* ========================================
     Fade-in Animations
     ======================================== */
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.process__step, .crystal-guide__card, .product-card, .brand-story__inner, .faq__item, .crystal-info__card').forEach(function (el) {
    el.classList.add('fade-in');
    observer.observe(el);
  });
});
